/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';

interface BvHrSignature {
  Args: {
    size?: 'full' | 'half' | 'quarter';
  };
  Element: HTMLElement;
}

const BvHrComponent = templateOnlyComponent<BvHrSignature>();

export default BvHrComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    BvHr: typeof BvHrComponent;
    'bv-hr': typeof BvHrComponent;
  }
}
